import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useDetailNotify = (id: number) =>
  useQuery(
    ['detailNotify', id],
    async () => {
      if (id) {
        const res = await api.get(`/api/cms/notification/${id}`);
        return res.data.data;
      }
      return;
    },
    {
      retry: 0,
    }
  );
